import { Tooltip as MuiTooltip } from '@mui/material';
import type { TooltipProps } from '@mui/material';
import type { ReactElement } from 'react';

interface CustomTooltipProps {
  title: string;
  children: ReactElement;
  placement?: TooltipProps['placement'];
}

export default function Tooltip({ title, children, placement = 'top-start' }: CustomTooltipProps) {
  return (
    <MuiTooltip
      title={title}
      placement={placement}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -8],
              },
            },
          ],
        },
      }}
    >
      {children}
    </MuiTooltip>
  );
}
